/**
 * Created by Victor Rojo on 11/2/19.
 */
import { Component, ViewChild, ElementRef, AfterContentInit, OnDestroy }     from '@angular/core';

import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize, NgxGalleryLayout } from 'ngx-gallery';

import {ClearViewService} from "../clearView/ClearView.service";
import {Globals} from "../../globals";

@Component({
  templateUrl: './Reconciliation.component.html',
  styleUrls: ['./Reconciliation.component.css']
})
export class ReconciliationComponent implements AfterContentInit, OnDestroy {

  @ViewChild('form', { static: true }) form: ElementRef;
  @ViewChild('__VIEWSTATEGENERATOR', { static: true }) __VIEWSTATEGENERATOR: ElementRef;
  @ViewChild('__EVENTVALIDATION', { static: true }) __EVENTVALIDATION: ElementRef;
  @ViewChild('__VIEWSTATE', { static: true }) __VIEWSTATE: ElementRef;
  @ViewChild('txtUsername', { static: true }) txtUsername: ElementRef;
  @ViewChild('txtPassword', { static: true }) txtPassword: ElementRef;
  @ViewChild('Submit1', { static: true }) Submit1: ElementRef;

  private promise: Promise<any>;
  private formUpdated = false;
  isLoading = false;
  private firstLoad = true;

  galleryImages: any;
  galleryOptions: any;
  image = "assets/images/mock_menus/reconcilliation.png";
  mock = true;
  showAsThumbnail = true;

  constructor(private clearViewService:ClearViewService,
              private globals: Globals) {

    if ( globals.tenant == "ecomanager" ) {
      this.mock = false;
      this.isLoading = true;
      this.promise = this.clearViewService.getLoginParams();
      this.waitForData();
    } else if ( globals.tenant == "ecuador" || globals.tenant == "demoipetrol" || globals.tenant == "ask" ) {
      this.showAsThumbnail = false;
    } else {
      this.galleryOptions = [
        {
          width: '300px',
          height: '330px',
          preview: true,
          layout: NgxGalleryLayout.ThumbnailsBottom,
          image: false,
          thumbnailSize: NgxGalleryImageSize.Contain,
          previewCloseOnEsc: true,
          previewCloseOnClick: true,
          thumbnails: true,
          previewFullscreen: true,
          previewZoom:true,
          thumbnailsColumns: 1

        }
      ];

      this.galleryImages = [{
        small: this.image,
        medium: this.image,
        big: this.image
      }];
    }

  }

  waitForData(){
    setTimeout(()=>{
      if ( this.formUpdated && !this.firstLoad) {
        this.form.nativeElement.submit();
      } else {
        this.waitForData();
      }
    }, 200);
  }

  ngAfterContentInit(){
    if ( this.promise ) {
      this.promise.then( credentials => {
        this.__VIEWSTATEGENERATOR.nativeElement.value = credentials.__VIEWSTATEGENERATOR;
        this.__EVENTVALIDATION.nativeElement.value = credentials.__EVENTVALIDATION;
        this.__VIEWSTATE.nativeElement.value = credentials.__VIEWSTATE;
        if ( credentials.txtUsername && credentials.txtPassword) {
          this.txtUsername.nativeElement.value = credentials.txtUsername;
          this.txtPassword.nativeElement.value = credentials.txtPassword;
        }
        this.Submit1.nativeElement.value = credentials.Submit1;
        this.formUpdated = true;
      })
    }
  }

  onLoad(){
    if ( this.firstLoad ) {
      this.firstLoad = false;
    } else {
      this.isLoading = false;
    }
  }

  public ngOnDestroy(): void {
    this.clearViewService.logout();
  }
}
